module.exports = __webpack_public_path__ + "static/assets/5f9402aed7fcece33a34c76e92a71189.gif";